{
  "close": "Zapri"
}
